import { useParamsSearch } from '@anytag/shared-hooks';
import { EngagementCampaignsSearchSchemaType } from '../schemaTypes';

export const useEngagementCampaignsFilter = () => useParamsSearch<EngagementCampaignsSearchSchemaType>();
